/**
 * External dependencies
 */
import { registerPlugin } from '@wordpress/plugins';
import { ExperimentalOrderMeta } from '@woocommerce/blocks-checkout';
import { getSetting } from '@woocommerce/settings';
/**
 * Internal dependencies
 */
import './style.scss';

import { registerFilters } from './filters';

const exampleDataFromSettings = getSetting( 'file-upload-checkout_data' );

const render = () => {
	return (
		<>
			<ExperimentalOrderMeta>
			</ExperimentalOrderMeta>
		</>
	);
};

registerPlugin( 'file-upload-checkout', {
	render,
	scope: 'woocommerce-checkout',
} );

registerFilters();
